{
  "static-content-online-booking-benefit": {
    "buttons": {},
    "text": {
      "title-1": "Book online and ",
      "title-2": "unlock exclusive benefits!",
      "description": "Experience the ultimate convenience with our online booking tool. Whether it's day or night, you can schedule appointments 24/7 from anywhere, using just your smart device and an internet connection. Plus, gain access to special offers like discounts and exclusive happy hour promotions. Take control of your appointments and enjoy the benefits of seamless online booking!",
      "any-time-title": "Book 24/7",
      "any-time-description": "Book your appointment online, no matter what time it is",
      "any-where-title": "Book from anywhere",
      "any-where-description": "From your bed, or on the way",
      "discount-title": "Best Deals",
      "discount-description": "Don't miss out on our best deals! Get great discounts and exclusive happy hour deals now"
    }
  }
}
